export const EXAM_TYPE_OPTIONS = [
  { value: 'Периодический', label: 'Периодический' },
  { value: 'Предварительный', label: 'Предварительный' },
  { value: 'Внеочередной', label: 'Внеочередной' },
] as const;
